import progressitem from "./progressitem";
import Vue from "vue";

export default () => {
    Vue.component("ProgressItem", progressitem);
};